/* eslint-disable react/require-default-props */
import { FormControl, FormLabel, Slider } from '@mui/material';
import React, { useCallback } from 'react';

type SliderProps = React.ComponentProps<typeof Slider>;

type Props = {
	label: string;
	setValue: (value: string) => void;
	options: string[];
	value: string;
	marks?: SliderProps['marks'];
	valueLabelDisplay?: SliderProps['valueLabelDisplay'];
	valueLabelFormat?: SliderProps['valueLabelFormat'];
	// eslint-disable-next-line react/no-unused-prop-types
	order?: number;
};

const SliderControl: React.FC<Props> = ({
	options = [],
	value,
	setValue,
	label,
	marks,
	valueLabelDisplay,
	valueLabelFormat,
	order
}: Props) => {
	const onChange = useCallback(
		(_: any, v: number | number[]) => setValue(options[v as number]),
		[setValue, options]
	);

	return (
		<FormControl fullWidth margin="normal" component="fieldset" sx={{ order }}>
			<FormLabel component="legend">{label}</FormLabel>
			<Slider
				size="small"
				step={1}
				min={0}
				max={options.length - 1}
				value={options.indexOf(value)}
				onChange={onChange}
				marks={marks}
				valueLabelDisplay={valueLabelDisplay}
				valueLabelFormat={valueLabelFormat}
			/>
		</FormControl>
	);
};

SliderControl.defaultProps = {
	marks: false
};

const MemoSliderControl = React.memo(SliderControl);

export { MemoSliderControl as SliderControl };
